/**
 * Shared Tailwind classes for the public auth screens (login + signup) so the
 * two flows cannot drift apart when one of them is restyled.
 */

/**
 * Base for every auth text input: icon gutter on the left, warm tinted fill.
 * Border / focus colours come from `authInputClass` so an invalid field can
 * swap them for the red variants.
 */
export const AUTH_INPUT_BASE =
  "w-full rounded-xl border bg-[#fff3e0]/50 py-3 pl-10 text-sm text-[#333] placeholder:text-gray-400 transition-all focus:bg-white focus:outline-none";

export const AUTH_INPUT_VALID =
  "border-gray-200 focus:border-[#ffa217]/50 focus:ring-2 focus:ring-[#ffa217]/30";

export const AUTH_INPUT_INVALID =
  "border-red-400 focus:border-red-400 focus:ring-2 focus:ring-red-200";

/** `hasToggle` reserves room for the show/hide password button. */
export const authInputClass = (invalid = false, hasToggle = false) =>
  `${AUTH_INPUT_BASE} ${hasToggle ? "pr-10" : "pr-3.5"} ${
    invalid ? AUTH_INPUT_INVALID : AUTH_INPUT_VALID
  }`;

/** Country-code select next to the phone input. */
export const AUTH_SELECT_CLASS =
  "shrink-0 rounded-xl border border-gray-200 bg-[#fff3e0]/50 px-3 py-3 text-sm text-[#333] focus:border-[#ffa217]/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#ffa217]/30";

export const AUTH_LABEL_CLASS = "mb-1.5 block text-sm font-medium text-gray-700";

export const AUTH_PRIMARY_BUTTON_CLASS =
  "w-full rounded-xl bg-[#ffa217] py-3 text-sm font-semibold text-white transition-all shadow-sm hover:bg-[#e08f0e] active:scale-[0.98]";

/**
 * Card that holds an auth panel (the signup stepper and each signup step).
 * The auth shell paints the form column white, so the card needs a hairline
 * border to stay visible.
 */
export const AUTH_CARD_CLASS =
  "rounded-2xl border border-gray-100 bg-white p-8 shadow-sm";

/** Compact variant of `AUTH_CARD_CLASS` for the signup progress indicator. */
export const AUTH_STEPPER_CARD_CLASS =
  "rounded-2xl border border-gray-100 bg-white px-6 py-4 shadow-sm";

export const AUTH_FOOTER_TEXT_CLASS = "mt-6 text-center text-sm text-gray-500";

export const AUTH_FOOTER_LINK_CLASS = "font-semibold text-[#ffa217] hover:text-[#e08f0e]";
